export default __webpack_public_path__ + "static/media/img-gastronomy.aa9dedc8.jpg";